import React from 'react';
import { DateItem, TcsmDatesBlock } from '../../models/tcsm-block-models';
import { ContentSpacer } from '../layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';


interface Props {
    blockData: TcsmDatesBlock,
}

export function TcsmDatesBlockView(props: Props) {

    const { blockData } = props;

    function RenderSmallSubtitle() {
        if (blockData?.pageSmallTitle) {
            return (<>
                {blockData.pageSmallTitle}
            </>);
        }
    }

    function RenderDate(dateItem: DateItem) {
        return (
            <li className='dates-block-list-item'>
                <div className='dates-block-list-item-date'>
                    <p><span className='month'>{dateItem?.month}</span>
                    <span className='day'>{dateItem?.day}</span></p>
                </div>
                <div className='dates-block-list-item-description'><WysiwygWithReactLink content={dateItem?.description} /></div>
            </li>
        );
    }

    function RenderDates() {
        if (blockData?.dateList) {
            return (
                <ul className='dates-block-list'>
                    {blockData?.dateList.map(date => RenderDate(date))}
                </ul>
            );
        }
    }

    return (
        <section className="adage-block">
            <ContentSpacer>
                <h2>{blockData?.pageTitle}</h2>
            </ContentSpacer>
            <ContentSpacer>
                <WysiwygWithReactLink content={blockData?.description} />
            </ContentSpacer>
            <h3>{RenderSmallSubtitle()}</h3>
            {RenderDates()}
        </section>
    );
}

export default TcsmDatesBlockView;
